// -- other --
import {useState,useEffect} from "react";
import {Link,useNavigate} from "react-router-dom";
import ImageWithBasePath from "../../../core/img";
import Slider from 'react-slick';
import {all_routes} from "../../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// -- biz9 --
import {UrlParam} from "biz9-react-utility";
import {UrlQuery} from "biz9-react-utility";
import {Log,Response_Logic,DateTime,Str} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {Data_Logic} from "biz9-data-app";
import {Message,Config,Title} from "../../../constant";
import {App,Field_Logic,Image,Toast_Message,Storage} from "../../../project";
import SubValue from "../../subValue";
import {Portal_Type,Portal_Field,Portal_Table,Portal_Stat,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Page,Portal_Remote_Data,Sub_Value_Type} from "biz9-portal-app";

const Blog_Post_Detail = () => {
    const query = UrlQuery();
    const param = UrlParam();
    // -- page-edit --
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
 const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));

 const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
 const [edit_mode,setEditMode] = useState(false);
    // -- main --
    const [blog_post, setBlogPost] = useState(Data_Logic.get(Portal_Table.BLOG_POST,0));
    const [val_title_url,setValTitleUrl] = useState(null);
    const [blog_posts, setBlogPosts]= useState([]);
    const [tags, setTags]= useState([]);
    const [selectedItems, setSelectedItems] = useState(Array(10).fill(false));
    const handleItemClick = (index: number) => {
        setSelectedItems((prevSelectedItems) => {
                const updatedSelectedItems = [...prevSelectedItems];
                updatedSelectedItems[index] = !updatedSelectedItems[index];
                return updatedSelectedItems;
                });
    };
    const settings1 = {
dots: false,
      nav: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 3,
            },
      },
      {
breakpoint: 700,
            settings: {
slidesToShow: 2,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
    };
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_page_data();
    }, []);

      useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        if(param.title_url){
            get_items_data(param.title_url);
        }
    }, [param.title_url]);
    async function get_page_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.BLOG_POST.title_url,option);
        bind_page(data);
    };
    async function get_items_data(title_url) {
        // -- remote-data-response --
        let search_blog_post = Data_Logic.get_search(Portal_Table.BLOG_POST,{});
        let join_blog_post = Data_Logic.get_join(Portal_Value_Type.ITEMS, search_blog_post,{title:Portal_Type.BLOG_POSTS});
        let option = {get_cache:false,time_limit:10,joins:[join_blog_post]};
        const [response,data] = await Portal_Remote_Page.get_blog_post_items(App.get_url(Portal_Page.BLOG_POST[Portal_Type.ITEMS_URL]),title_url,option);
        Log.w('11_data',data);
        bind_items(title_url,data);
        Toast_Message.dismiss();
    }
    async function bind_page(data) {
        // -- page-template --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
    };
	async function bind_items(title_url,data) {
        // -- item --
        setValTitleUrl(title_url);
        // -- blog_post --
        setBlogPost(data[Portal_Type.BLOG_POST]);
        // -- items --
        setBlogPosts(data[Portal_Type.BLOG_POSTS]);
	}
    //* ---- BIND-SUB-VALUES ----
    async function bind_sub_values(data_sub_group) {
        // -- sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
    //* ---- UPDATE-SUB-VALUE ----
     async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                }
            }));
        }else{
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                }
            }));
        }
    }

    return (
            <>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
            <div className="breadcrumb-img">
            <div className="breadcrumb-left">
            <ImageWithBasePath src="/assets/img/bg/breadcrump-bg-01.png" alt="img" />
            </div>
            </div>
            <div className="container">
            <div className="row">
            <div className="col-md-12 col-12">
            <nav aria-label="breadcrumb" className="page-breadcrumb">
            <ol className="breadcrumb">
            <li className="breadcrumb-item">
            <Link to={all_routes.home}>Home</Link>
            </li>
            <li className="breadcrumb-item">
            <Link to={all_routes.blog_post}>{Title.LABEL_NEWZ_UPDATEZ}</Link>
            </li>
            <li className="breadcrumb-item" aria-current="page">
            Details
            </li>
            </ol>
            </nav>
            <h2 className="breadcrumb-title">
            {blog_post.title}
    </h2>
        </div>
        </div>
        </div>
        <div className="breadcrumb-img">
        <div className="breadcrumb-right">
        <ImageWithBasePath src="/assets/img/bg/breadcrump-bg-02.png" alt="img" />
        </div>
        </div>
        </div>
        {/* /Breadcrumb */}
    {/* Page Content */}
    <div className="page-content">
        <div className="container">
        {/* Blogs */}
    <div className="row">
    {/* Blog Details */}
    <div className="col-lg-10 mx-auto">
        <div className="blog-details">
        <div className="blog-detail-img">
        <ImageWithBasePath
        src={Image.get_url(blog_post.image_filename,Image_Format.SQUARE_LARGE)}
    className="img-fluid"
        alt="img"
        />
        </div>
        <div className="blog-content border-bottom d-flex align-items-center justify-content-between pb-4 mb-4">
        <div className="user-info">
        <div className="d-flex align-items-center">
        <p className="me-3">
        <Link to="#">{blog_post.author}</Link>
        </p>
        <span className="d-flex align-items-center me-3">
        <i className="feather icon-calendar me-1" />
        {DateTime.get_date_short(blog_post.date_create)}
    </span>
        <span className="d-flex align-items-center">
        </span>
        </div>
        </div>
        <span className="badge-text me-3">{blog_post.category}</span>
        </div>
        <div className="blog-contents">
        <p dangerouslySetInnerHTML={{__html: Str.get_quill_html(blog_post.note)}}></p>
        </div>
        <div className="d-flex align-items-center mb-4">
        {tags.map((item) => (
                    <span className="badge-text me-3">{item}</span>
                    ))}
    </div>
        </div>
        </div>
        {/* /Blog Details */}
    </div>
        </div>
        </div>
        {/* /Page Content */}
    {/* Related Posts */}
    <div className="relate-post-section">
        <div className="container">
        <div className="row">
        <div className="col-md-12">
        <div className="d-flex align-items-center justify-content-center">
        <h3>Related Posts</h3>
        </div>

        <div className="relate-slider owl-carousel">
        <Slider {...settings1}>
        {blog_posts.map((item) => (
                    <div className="blog-grid">
                    <div className="blog-img">
                    <Link to={"/blog/"+item.title_url}>
                    <ImageWithBasePath
                    src={Image.get_url(item.image_filename,Image_Format.SQUARE_THUMB)} className="img-fluid"alt="img"/>
                    </Link>
                    </div>
                    <div className="blog-content">
                    <div className="user-head">
                    <div className="badge-text">
                    <Link to={"/blog/"+item.title_url} className="badge bg-primary-light">
                    {item.category}
                    </Link>
                    </div>
                    </div>
                    <div className="blog-title">
                    <h3>
                    <Link to={"/blog/"+item.title_url}>
                    {item.title}
                    </Link>
                        </h3>
                        <p>
                        {item.description}
                    </p>
                        </div>
                        <div className="blog-content-footer d-flex justify-content-between align-items-center">
                        <div className="user-info">
                        <div className="d-flex align-items-center">
                        <p className="me-2">
                        <Link to="">{item.author}</Link>
                        </p>
                        <span className="dot me-2" />
                        <span>{DateTime.get_date_short(item.date_create)}</span>
                        </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        ))}
    </Slider>
        </div>
        </div>
        </div>
        </div>
         <SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />

        </div>
        {/* /Related Posts */}
    </>
        )
}
export default Blog_Post_Detail
